var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status noselect",on:{"click":_vm.connectEstablishment}},[_c('div',{class:_vm.status ? 'establishment-status' : 'establishment-status offline'},[_c('p',[_vm._v(_vm._s(_vm.getStatusText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }